import React, { useState} from 'react';
import { Thead, Load } from './partials/PopUps.js';
import { toast } from 'react-toastify';
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { HistorialVentaProducto } from './Reportes/HistorialVentaProducto.js';
import Todos from './Reportes/Todos.js';
import es from 'date-fns/locale/es';
registerLocale('es',es);
function ItemsProduct({ producto, index, verHistorial }){
	const precio = producto.precio;
	return (
		<tr key={index} className={precio<1?'error':''}>
			<td>{producto.codigo}</td>
			<td className="text-left">{producto.nombre}</td>
         	<td>{window.$fmoney(precio,2)}</td>
			<td>{producto.ventas}</td>
			<td>{producto.cambios}</td>
			<td className="text-cente">
				{producto.ventas - producto.cambios}
			</td>
			<td className="operaciones">
				<span className="icon-view" onClick={()=>verHistorial(producto.id, producto.sucursal)}></span>
			</td>
		</tr>
	)
}
const Item = ({clave, sucursal}) => {
	const salidas = sucursal.cantVentas - sucursal.cantCambios;
	return <div key={clave} className='xs-12 sm-3 md-3 lg-3'>
		<p><strong>Sucursal:</strong> {sucursal.nombre}</p>
		<p><strong>Ventas: </strong> {sucursal?.cantVentas?sucursal.cantVentas:0}</p>
		<p><strong>Cambios:</strong> {sucursal?.cantCambios?sucursal.cantCambios:0}</p>
		<p><strong>Salidas: </strong> {isNaN(salidas)?0:salidas}</p>
		<p><strong>Total:</strong> {sucursal?.total ? window.$fmoney(sucursal.total,2): 0}</p>
	</div>
}
const Producto = ({sucursales}) => {
	const codigo = React.useRef();
	const [startDate, setStartDate] = useState(new Date());
	const [dateEnd, setDateEnd] = useState(new Date());
	const [response, setResponse ] = useState([]);
	const [total, setTotal ] = useState(0);
	const [fadeIn, setFadein]=useState(false);
	const [producto, setProducto ] = useState({
		cantidad:'',
		codigo:'',
		id:0,
		precio:'',
		stock:0
	});
	const formatDate = _date => {
		_date = _date.split('/');
		let d = _date[0];
		let m = _date[1];
		d = d < 10 ? '0'+d : d;
		m = m < 10 ? '0'+m : m;
		return ( _date[2]+'-'+m+'-'+d);
	}
	const ajaxGetProduct = () => {
		const options = { year : 'numeric', month : 'numeric', day : 'numeric'};
		if( startDate != null && dateEnd != null ){
			let initDate = startDate.toLocaleDateString('es-Es', options);
			let _dateEnd = dateEnd.toLocaleDateString('es-Es', options);
			initDate = formatDate(initDate);
			_dateEnd = formatDate(_dateEnd);
			const _codigo = codigo.current.value+'_'+
								initDate+'_'+
								_dateEnd;
			if( codigo.current.value !== '' ){
				
				setFadein(true);
				fetch(window.$api+'/getVentasxproducto/'+_codigo)
				.then(res=>res.json())
				.then(res=>{
					if( res.status === 200 ){
						setProducto(res.data);
						setResponse(res.sucursales);
						setTotal(res.total);
					}else{
						setProducto([]);
						setResponse([]);
						toast.warning(res.message);			
					}
					setFadein(false);
				});
			}else{
				toast.warning('Ingrese el código de producto y una fecha de búsqueda');	
			}
		}else{
			toast.warning('Seleccione una fecha de búsqueda');	
		}
	}
	let sucursal = {};
	let htmlItems = [];
	if( response.length > 0 ){
		sucursales.forEach((sucD,i)=>{
			sucursal = response.find(e=>parseInt(e.id)===parseInt(sucD.id));
			if( sucursal ){
				htmlItems.push(<Item sucursal={sucursal} clave={i}/>);
			}else{
				htmlItems.push(<Item sucursal={sucD} clave={i}/>);	
			}
		});
	}
	
	return <div className='xs-12 sm-12 md-12 lg-12 no-padding'>
			<div className='xs-12 sm-3 md-3 lg-3'>
				<label>Buscar producto</label>
				<input name='producto' 
						ref={codigo} 
						style={{height:'34px'}}
						className='input-normal'></input>
			</div>
			<div className="xs-12 sm-3 md-3 lg-3">
				<label>Fecha inicial :</label>
				<DatePicker
				 	dateFormat="dd-MM-yyyy"
					selected={startDate}
					onChange={date =>setStartDate(date)} 
					locale='es'
					className='input-normal'
				/>
			</div>
			<div className="xs-12 sm-3 md-3 lg-3">
				<label>Fecha final:</label>
				<DatePicker
				 	dateFormat="dd-MM-yyyy"
					selected={dateEnd}
					onChange={date =>setDateEnd(date)} 
					locale='es'
					className='input-normal'
				/>
			</div>
			<div className='xs-12 sm-2 md-2 lg-2'>
				<div className='btn btn-green btn-small' onClick={ajaxGetProduct} style={{padding:'8px 12px',top:'16px'}}>Buscar</div>
			</div>
			<div className='xs-12 sm-12 md-12 lg-12'>
				<br/><hr/>
			</div>
			<div className='xs-12 sm-3 md-3 lg-3'>
				<p><strong>Código: </strong>{producto.codigo}</p>
			</div>
			<div className='xs-12 sm-3 md-3 lg-3'>
				<p><strong>Nombre: </strong>{producto.nombre}</p>
			</div>
			<div className='xs-12 sm-3 md-3 lg-3'>
				<p><strong>Cantidad:</strong> {total}</p>
			</div>
			
			<div className='xs-12 sm-3 md-3 lg-3'>
				<p><strong>Precio: </strong>{window.$fmoney(producto.precio,2)}</p>
			</div>
			<div className='xs-12 sm-12 md-12 lg-12'>
				<hr/>
			</div>
			{htmlItems}
			<Load display={fadeIn} />
	</div>
}

class Rgeneral extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			ventas : [],
			sucursalID : '',
			sucursales : [],
			ventasDefault : [],
         	totalUnidades : 0,
         	generaTotal : 0,
			generaCurrent : 0,
			total : 0,
			general : true,
			porproducto : false,
         	pagination : 1,
         	begin : 0,
			pagina : 1,
			date : new Date(),
			display : { load : false },
			filt_sucursal : '',
			filt_dateInit : '',
			filt_dateFinal : '',
			filt_sucursal_id : 0,
			dataModal : [],
			showMHVP : false,
			startDate : new Date(),
			dateEnd : new Date(),
			pgeneral : true,
			psucursal : false,
			pporproducto : false,
			totalSucursal : 0
		}
		this.static = {
			columns : ['Código', 'Producto', 'Precio','Ventas','Cambios','Salidas','Acción'],
			ruta : 'http://tienda-shantal.com/store/api/downReport/',
		}
	}
	componentDidMount(){
		fetch(window.$api + '/getReporteGeneral')
		.then(res=>res.json()).then(
			sucursales => {
				this.setState({sucursales});
			},
			error=>{
				console.log(error);
			}
		);
	}
	actived(arg){
		return this.props.match.path === arg ? 'actived' : '';
	}
   	getProductsSucursal = e => {
		const value = e.target.value;
		this.setState({ filt_sucursal_id : value });
	}
	formatDate = _date => { //
		const options = { year : 'numeric', month : 'numeric', day : 'numeric'};
		let fecha = _date.toLocaleDateString('es-Es', options);
		fecha = fecha.split('/');
		let d = fecha[0];
		let m = fecha[1];
		d = d < 10 ? '0'+d : d;
		m = m < 10 ? '0'+m : m;
		return ( fecha[2]+'-'+m+'-'+d);
	}
	getReport = () => {
		const inicio = this.formatDate(this.state.startDate);
		const fin = this.formatDate(this.state.dateEnd);
		if( this.state.filt_sucursal_id ){
			// Validamos fechas
			if( inicio !== "" &&  fin !== "" ){
				const display = { load : !this.state.display.load };
				this.setState({display});
				const sucursal_id = this.state.filt_sucursal_id;
				fetch(window.$api+'/getVentasSucursal/'+sucursal_id+'_'+inicio+'_'+fin)
				.then(res=>res.json()).then(res=>{
				
					if( res.status === 200 ){
						const ventas = res.data;
						const totalSucursal = res.total
						const display = { load : !this.state.display.load };
						this.setState({ventas,display, totalSucursal});
					}else{
						toast.warning("Aún no hay ventas en esta sucursal");
						const ventas = [];
						const display = { load : !this.state.display.load };
						this.setState({display,ventas});
					}
				});
			}else{
				toast.warning("Ingrese el rango de fechas a consultar");
			}
		}else{
			toast.warning("Seleccione una sucursal para la consulta");
		}
	}
	getReportPDF = () => {
		const inicio = this.state.filt_dateInit;
		const fin = this.state.filt_dateFinal;
		if( this.state.filt_sucursal_id ){
			// Validamos fechas
			if( inicio !== "" &&  fin !== "" ){
				const display = { load : !this.state.display.load };
				this.setState({display});
				const sucursal_id = this.state.filt_sucursal_id;
				fetch(window.$api+'/getPDF/'+sucursal_id+'_'+inicio+'_'+fin)
				.then(res=>res.json()).then(res=>{
					const display = { load : !this.state.display.load };
					this.setState({display});
				});
			}else{
				toast.warning("Ingrese el rango de fechas a consultar");
			}
		}else{
			toast.warning("Seleccione sucursal o proveedor para la consulta");
		}
	}
	getClear = () => {
		this.setState({
			filt_sucursal : '',
			filt_dateInit : '',
			filt_dateFinal : '',
			filt_sucursal_id : 0,
			ventas : []
		})
	}
	closeHistorial = () => {
		this.setState({dataModal:[], showMHVP:false});
	}
	verHistorial = (producto, sucursal) => {
		const inicio = this.formatDate(this.state.startDate);
		const fin = this.formatDate(this.state.dateEnd);
		const display = { load : !this.state.display.load };
      	this.setState({display});
		fetch(window.$api + '/getHistorialVenta/'+producto+'/'+sucursal+'_'+inicio+'_'+fin)
		.then(res=>res.json())
		.then(
			ventas => {
				const display = { load : !this.state.display.load };
				this.setState({dataModal:ventas, showMHVP : true, display });
			},
			error => {
				console.log("Intente mas tarde");
			}
		);	
	}
	OrdenarResultado = flag =>{
		let ventas = this.state.ventas;
		if( flag === '+'){
			ventas.sort( (a,b) =>{
				if ( a.cantidad < b.cantidad ){
					return -1;
				}
				if ( a.cantidad > b.cantidad ){
					return 1;
				}
				return 0;
			});
			ventas.reverse();
		}else{
			ventas.reverse();
		}
		this.setState({ventas})
	}
	getDate = date => {
		let month = date.getMonth()+1;
		month = month < 10 ? 0+month : month;
		return date.getFullYear()+'-'+month+'-'+date.getDate();
	}
   	getChunks = (begin, pagination, pagina) => {
      const display = { load : !this.state.display.load };
      this.setState({display});
      fetch(window.$api + '/getReporteGeneral/'+begin+'/'+pagination+'/chunks')
      .then(res=>res.json()).then(
			success => {
            const ventas = JSON.parse( JSON.stringify( success.ventas ) );
            const pagination = ventas.length;
            const generaTotal = success.ventasTotales;
            let totalUnidades = 0;
            let total = 0;
				ventas.forEach( producto =>{
               totalUnidades += Number( producto.cantidad );
					total = producto.cantidad * producto.precio;
            });
            const display = { load : !this.state.display.load };
				this.setState({ventas,generaTotal,total,totalUnidades,pagination,begin, display,pagina});
			},
			error=>{
				console.log(error);
			}
		);
   	}
   	pagination = (direction) => {
      let begin = this.state.begin;
      let pagination = this.state.pagination;
      let pagina = this.state.pagina;
      if( direction === 'next' && pagination < this.state.generaTotal ){
         begin = begin + Number( 10 );
         pagination = pagination + Number( 10 );
         pagina+=Number(1);
         this.getChunks( begin, pagination, pagina );
      }
      if( direction === 'prev' && begin > 0){
         begin = begin - 10;
         pagina-=Number(1);
         pagination = pagination - 10;
         this.getChunks( begin, pagination, pagina );
      }
	}
	showPanel = panel =>{
		this.setState({ pgeneral : false, psucursal : false, pporproducto : false });
		this.setState({ [panel] : !this.state[panel] });
	}
	render(){
		const btnBuscar = {
			width:'auto', 
			position: 'relative',
			padding : '6px 30px', 
			top:'15px',
			fontSize : '16px'
		}
		let list = [];
		let cantVentas = 0, cantCambios = 0, totalCambios = 0;

		if( this.state.ventas.length > 0 ){
			this.state.ventas.forEach((e, index)=>{
				cantVentas += parseInt( e.ventas );
				cantCambios += parseInt( e.cambios);
				totalCambios += (parseInt( e.cambios) * e.cambios );
				list.push(
					<ItemsProduct 
						producto={e} 
						key={index}
						verHistorial={this.verHistorial}
					/>
				);
			})
		}
		const styleBtn = {background:'#f1aad1',color:'#fff'};
		
		return(
			
			<div className="wrap-module">
				<h1>Reportes</h1>
				<div className='link-module'>
					<span style={ this.state.pgeneral ? styleBtn : {}} onClick={()=>this.showPanel('pgeneral')}>Todas las sucursales</span>
					<span style={ this.state.psucursal ? styleBtn : {}} onClick={()=>this.showPanel('psucursal')}>Por sucursales</span>
					<span style={ this.state.pporproducto ? styleBtn : {}} onClick={()=>this.showPanel('pporproducto')}>Por producto</span>
				</div>
				<div className="wrap-content bordertr">
					<div style={ { display: (this.state.pgeneral?'block':'none')}}>
						<Todos self={this} ></Todos>
					</div>
					{this.state.psucursal&&
						<>
							<div className="xs-12 sm-3 md-3 lg-3">
								<label>Sucursal:</label>
								<select 
									onChange={this.getProductsSucursal} 
									cl assName="select" 
									value={this.state.filt_sucursal_id}
									style={{padding:'4px 10px 4px 20px'}}
								>
								<option value="all">- Seleccione una opción -</option>
								{
									this.state.sucursales.length > 0 && 
									this.state.sucursales.map(e=><option key={e.id} value={e.id}>{e.nombre}</option>)
								}
								</select>
							</div> 
							<div className="xs-12 sm-3 md-3 lg-3">
								<label>Fecha de inicio:</label>
								<DatePicker
									dateFormat="dd-MM-yyyy"
									selected={this.state.startDate}
									onChange={startDate =>{ 
										const filt_dateInit = this.getDate(startDate);
										this.setState({ startDate, filt_dateInit});
									}}
									locale='es'
									className='input-normal'
								/>
							</div>
							<div className="xs-12 sm-3 md-3 lg-3">
								<label>Fecha final:</label>
								<DatePicker
									dateFormat="dd-MM-yyyy"
									selected={this.state.dateEnd}
									onChange={dateEnd =>{ 
										const filt_dateFinal = this.getDate(dateEnd);
											this.setState({ dateEnd, filt_dateFinal}) 
										} 
									}
									locale='es'
									className='input-normal'
								/>
							</div>
							<div className="xs-12 sm-3 md-3 lg-3">
								Ventas totales:  {window.$fmoney(this.state.totalSucursal,2)} <br/>
								Cambios: {window.$fmoney(totalCambios,2)}
							</div>
							<div className="xs-12 sm-12 md-12 lg-12"  style={{padding:'0px 0px'}}>
								<div className="btn-square btn-green" style={btnBuscar} onClick={this.getReport}>Buscar</div>
								<div className="btn-square btn-green" style={btnBuscar} onClick={this.getClear}>Limpiar filtros</div>
								<div className="btn-square btn-green" style={btnBuscar} onClick={()=>this.OrdenarResultado('+')}>
									Producto más vendido
								</div>
								<div className="btn-square btn-green" style={btnBuscar} onClick={()=>this.OrdenarResultado('-')}>
									Producto menos vendido
								</div>
								<div style={ { display : 'inline-block', float : 'right', top:'15px',position:'relative'} }>
									{this.state.filt_dateInit&&
										<a
										href={
											this.static.ruta+
											this.state.filt_sucursal_id+'_'+
											this.state.filt_dateInit+'_'+
											this.state.filt_dateFinal
										}
										download="reporte.csv"
										style={{color:"#555"}}>
										Descargar reporte (.csv)
									</a>}
								</div>
							</div>
							<div></div>
							<table className="margintop30">
								{ this.static.columns.length > 0 && <Thead columns={this.static.columns}/>}
								<tbody id="bodyReport">
									{list}
								</tbody>
								<tfoot>
									<tr>
										<td colSpan="3"></td>
										<td className="text-center">
											{cantVentas}
										</td>
										<td className="text-center">
											{cantCambios}
										</td>
										<td className="text-center">
											{cantVentas-cantCambios}
										</td>
										<td></td>
									</tr>
								</tfoot>
							</table>
						</>
					}
					{this.state.pporproducto&&<Producto sucursales={this.state.sucursales}/>}
				</div>
            <Load display={this.state.display.load} />
				{	this.state.showMHVP && 
					<HistorialVentaProducto 
						data={this.state.dataModal}
						close={this.closeHistorial}
					/>
				}
			</div>
			
		);
	}
}
export default Rgeneral;